module.exports = __webpack_public_path__ + "static/media/dlgo-car.d8eb957a.svg";